import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

/**
 * This component is a container for a set of sidenav tabs.
 *
 * It has two slots for content: one for pinned tabs and one for unpinned tabs.
 * The "pinned" and "unpinned" names used to indicate the scroll behavior of the
 * sections. Currently, the whole sidenav scrolls as one. If we add more sections
 * in the future, we may want to rename or extend this to take arbitrary slots.
 */
@Component({
	standalone: true,
	imports: [MatDividerModule],
	selector: 'sp-sidenav-menu',
	template: `
		<nav class="sidenav-menu__pinned"><ng-content select="[pinned]"></ng-content></nav>
		<mat-divider></mat-divider>
		<nav class="sidenav-menu__unpinned"><ng-content></ng-content></nav>
	`,
	styleUrls: ['./sidenav-menu.component.scss'],
})
export class SidenavMenuComponent {}
